import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Container, Row, Col, Label, Input } from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import { Link } from 'react-router-dom';

class LandingAdmin extends Component {
    constructor(props) {
        super(props);

        let sel = {
            showUnset: true
        };

        this.activeServices = ['Unset'];
        this.props.clients.forEach(client => {
            client.services.filter(service => service.active).forEach(service => {
                if (this.activeServices.findIndex(item => item === service.name) === -1) {
                    this.activeServices.push(service.name);
                    sel["show" + this.getLetters(service.name)] = true;
                }
            });
        });
        this.activeServices.sort();

        this.state = sel;
    }

    getLetters = (str) => {
        this.props.info('LandingAdmin.js/getLetters (str)',str);
        return str.replace(/[^a-zA-Z]+/g, '');
    }

    onlySelect = (service) => {
        this.props.log('LandingAdmin.js/onlySelect (service)',service);
        let sel = {...this.state};
        Object.keys(this.state).forEach(key => {
            sel[key] = false;
        });
        sel[service] = true;
        this.setState(sel)
    }

    render() {
        this.props.info('LandingAdmin.js/render');
        return (
            (this.props.clients.length > 0) ?
                <>
                    <CollapseCard title="Admin Clients" open={true}>
                        <Container>
                            <Row className="text-left adminRow font-weight-bold">
                                {this.activeServices.map(service => (
                                    <div key={service} className="px-4 pull-left">
                                        <Label><Input
                                            type="checkbox"
                                            name={this.getLetters("show" + service)}
                                            checked={this.props.isFieldNull(this.state[this.getLetters("show" + service)],true)}
                                            onChange={() => this.setState((prevState) => {
                                                let sel = prevState;
                                                sel[this.getLetters("show" + service)] = !this.state[this.getLetters("show" + service)];
                                                return sel;
                                            })}
                                        /> {service}</Label><span onClick={()=>this.onlySelect(this.getLetters("show" + service))} className="pull-left px-2 onlySelect">Only</span>
                                    </div>
                                ))}
                            </Row>
                            {this.props.clients.filter(client => client.active === true &&
                                (
                                    (client.services.filter(service => service.active).map(service => this.getLetters("show" + service.name))
                                        .findIndex(service => this.state[service]) > -1) ||
                                    (this.state.showUnset &&
                                        client.services.filter(service => service.active).length === 0)
                                )
                            ).map(client => (
                                <Row key={client.id} className="mainRow">
                                    <Col md={12} className="text-left">
                                        <Link to={{ pathname: '/company/' + client.id }}>{client.client}</Link>
                                    </Col>
                                </Row>
                            ))}
                        </Container>
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default LandingAdmin;
